/**
 * Tour steps configuration
 * Each step defines what the guided tour will show to users
 */

// Dashboard Tour Steps
export const getDashboardTourSteps = () => {
  return [
    {
      target: 'body',
      content: 'Welcome to the SuprDrive! This guided tour will help you learn how to manage your SuprArt files.',
      placement: 'center',
      disableBeacon: true,
      title: '👋 Welcome to SuprDrive'
    },
    {
      target: '.bucket-selector',
      content: 'Switch between different storage buckets for your files: Live, Artwork, Video, and Gallery.',
      placement: 'top',
      title: '🗂️ Bucket Selector'
    },
    {
      target: '.live-bucket',
      content: 'The Live bucket is where your real-time sketches are saved while you draw. These files are automatically saved as you create.',
      placement: 'top',
      title: '🔴 Live Bucket'
    },
    {
      target: '.artwork-bucket',
      content: 'The Artwork bucket is where you store your finished pieces and organized collections. Move your best sketches here from the Live bucket.',
      placement: 'top',
      title: '🖼️ Artwork Bucket'
    },
    {
      target: '.video-bucket',
      content: 'The Video bucket stores your timelapse videos and other video content. Timelapses created from your artwork sequences will be saved here.',
      placement: 'top',
      title: '🎥 Video Bucket'
    },
    {
      target: '.gallery-bucket',
      content: 'The Gallery bucket contains artwork ready to be displayed in your public gallery. This is where you showcase your best work to others.',
      placement: 'top',
      title: '🏛️ Gallery Bucket'
    },
    {
      target: '.refresh-button',
      content: 'Refresh to see the latest files in your current folder.',
      placement: 'right',
      title: '🔄 Refresh Files'
    },
    {
      target: '.create-artwork-folder-button',
      content: 'Click here to create a new folder in your Artwork bucket to better organize your pieces. You\'ll want to do this first before moving your SuprArt files.',
      placement: 'right',
      title: '📁 Create Artwork Folder'
    },
    {
      target: '.move-to-artwork-button',
      content: 'Select files from your Live bucket and click here to move them to your Artwork bucket for permanent storage. Make sure you create a new artwork folder first!',
      placement: 'right',
      title: '📦 Move to Artwork'
    },
    {
      target: '.send-to-gallery-button',
      content: 'Select your best artwork and click here to add it to your Gallery bucket, making it available for public viewing on your public profile.',
      placement: 'right',
      title: '🌐 Send to Gallery'
    },
    {
      target: '.delete-button',
      content: 'Select files and click here to delete them.',
      placement: 'right',
      title: '🗑️ Delete Files'
    },
    {
      target: '.timelapse-button',
      content: 'With the Timelapse feature, you can generate a video from a sequence of images, perfect for showing the evolution of your artwork.',
      placement: 'right',
      title: '🎬 Timelapse'
    },
    {
      target: '.MuiTableRow-root:nth-child(2)',
      content: 'Browse and select your files and folders in this area. You can select multiple files by holding Ctrl/Cmd while clicking.',
      placement: 'top',
      title: '📄 File Browser'
    },
    {
      target: '.preview-panel',
      content: 'When you select a file, a preview will appear here. For images, you\'ll see a thumbnail and for videos, you can play them.',
      placement: 'left',
      title: '👁️ File Preview'
    },
    {
      target: 'body',
      content: 'You\'re now ready to use SuprDrive! If you need help, you can restart this tour by clicking the Tour button in the toolbar.',
      placement: 'center',
      disableBeacon: true,
      title: '🎉 All Set!'
    }
  ];
}; 